module.exports = __webpack_public_path__ + "static/media/undraw_diary_99km.a4ac10ff.png";